import { render, staticRenderFns } from "./QuoteAndOrderingSoftware.vue?vue&type=template&id=4254b64c&"
import script from "./QuoteAndOrderingSoftware.vue?vue&type=script&lang=js&"
export * from "./QuoteAndOrderingSoftware.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports